/**
 * Use this method to show formatted number in application
 *
 * @param {string}
 *
 * @return {string} formatted number
 */

export function getFormattedNumber(x) {
  if (x === null || x === undefined || x === "") return "";

  const num = Number(String(x).replaceAll(",", ""));

  if (isNaN(num)) return "";

  const isMinus = num < 0;
  const absolute = Math.abs(num);

  // Only show decimals when the original value has decimals
  const hasDecimal = !Number.isInteger(num);

  const fixed = hasDecimal
    ? absolute.toFixed(2)
    : absolute.toString();

  const [integer, decimal] = fixed.split(".");

  const formattedInteger = integer.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  return `${isMinus ? "-" : ""}${formattedInteger}${
    decimal ? `.${decimal}` : ""
  }`;
}